/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Model_Provider_Switch_WarningInputs */



/**
* | output |
* | --- |
* | "Switching models mid-chat may reduce response quality." |
*
* @param {Chat_Model_Provider_Switch_WarningInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_model_provider_switch_warning = /** @type {((inputs?: Chat_Model_Provider_Switch_WarningInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Model_Provider_Switch_WarningInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ein Modellwechsel mitten im Chat kann die Antwortqualität verringern.")
	return /** @type {LocalizedString} */ ("Switching models mid-chat may reduce response quality.")
});